const WorkCard = ({ id, onClick }) => {
  return (
    <div className='group relative overflow-hidden border-2 border-white/50 rounded-xl cursor-pointer z-0' onClick={onClick}>
     {/*overlay*/}
     <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'/>
     {/*img*/}
     <img 
       src={id.img} 
       alt={id.alt} 
       className='group-hover:scale-125 transition-all duration-500'
     />
     {/*pretitle*/}
     <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
       <span className='text-gradient'>
         {id.pretitle}
       </span>
     </div>
     {/*title*/}
     <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'>
       <span className='text-3xl text-white'>
         {id.title}
       </span>
     </div>
    </div>
  )
}

export default WorkCard;